import { TimeOptions } from './time-options';

import { GridCellContentAlignment } from '@grid/enums';
import { IAutoFocus } from './autofocus.model';
import { ColorOptions } from './color-options';
import { DateInputOptions } from './date-input-options.model';

export interface DateCellConfig extends IAutoFocus {
  options?: DateInputOptions;
  autoOpen?: boolean;
  justifyContentForDisplay?: boolean;
  alignment?: GridCellContentAlignment;
  colorOptions?: ColorOptions;
  clearButtonLabel?: string;
  allowClearOption?: boolean;
  saveButtonLabel?: string;
  timeOptions?: TimeOptions;
  format?: string;
}
